import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const ExReceptionPage = lazy(
  () =>
    import("../../../../../components/WMS/ExReceptions/ExReceptionPage.tsx"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/ex-receptions/$exReception",
)({
  validateSearch: (search: Record<string, unknown>) => {
    const next: { tab: "general" | "info" | "files"; edit?: 1 } = {
      tab:
        search.tab === "info"
          ? "info"
          : search.tab === "files"
            ? "files"
            : "general",
    }
    if (search.edit === 1 || search.edit === "1") {
      next.edit = 1
    }
    return next
  },
  component: ExReceptionRoute,
})

function ExReceptionRoute() {
  return (
    <LazyRoutePage>
      <ExReceptionPage />
    </LazyRoutePage>
  )
}
